import { createTheme } from '@mui/material/styles'

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#262626',
            light: '#404040',
            dark: '#171717',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#dc004e',
            light: '#ff5983',
            dark: '#9a0036',
            contrastText: '#fff',
        },
        background: {
            default: '#f9f9f9',
            paper: '#ffffff',
        },
        text: {
            primary: '#1A1A1A',
            secondary: '#666666',
        },
    },
    typography: {
        fontFamily: ['Urbanist'].join(','),
        fontSize: 15,
        button: {
            fontFamily: 'Urbanist',
            fontSize: '12px',
            fontWeight: 300,
            textTransform: 'none',
            lineHeight: 1,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ theme }) => ({
                    padding: '10px 24px',
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    gap: '6px',
                    boxSizing: 'border-box',
                    '&:hover': { backgroundColor: theme.palette.secondary.light },
                    '&:active': { backgroundColor: theme.palette.primary.dark },
                }),
                outlined: ({ theme }) => ({
                    border: `1px solid ${theme.palette.primary.main}`,
                    backgroundColor: 'transparent',
                    color: theme.palette.primary.main,
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.light,
                        color: theme.palette.primary.contrastText,
                        borderColor: 'transparent',
                    },
                }),
            },
        },
        MuiCard: {
            styleOverrides: {
                root: { borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: { padding: '40px', '&:last-child': { paddingBottom: '40px' } },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: { fontSize: '12px' },
            },
        },
    },
})

export default theme
